const staffRoleInfo = [
  {
    name: 'Billing Manager',
    summary: 'ইনভয়েস, ম্যানুয়াল কালেকশন ও আর্থিক রিপোর্ট তত্ত্বাবধানে এই রোল ব্যবহার করুন।',
    tasks: [
      'সমস্ত গ্রাহকের ইনভয়েস তৈরি ও আপডেট',
      'বকেয়া/অপরিশোধিত রিপোর্ট দেখার ক্ষমতা',
      'পেমেন্ট এন্ট্রি বা সমন্বয় অনুমোদন',
    ],
    recommendedFor: 'Accounts / Billing Team',
  },
  {
    name: 'Support Agent',
    summary: 'সাপোর্ট টিকিট এবং গ্রাহক প্রোফাইল আপডেটের সীমিত অ্যাক্সেস দেয়।',
    tasks: [
      'টিকিট দেখা ও আপডেট করা',
      'গ্রাহকের সার্ভিস স্ট্যাটাস যাচাই',
      'গ্রাহক প্রোফাইলে ছোটখাটো সংশোধন',
    ],
    recommendedFor: 'CSR / Helpdesk',
  },
  {
    name: 'Field Technician',
    summary: 'ফিল্ড অপ্স/NOC সদস্যদের জন্য ডিভাইস ও নেটওয়ার্ক টাস্ক চালু করার অনুমতি।',
    tasks: [
      'রাউটার বা PPP সংক্রান্ত তথ্য দেখা',
      'নেটওয়ার্ক টাস্ক/স্ক্রিপ্ট চালানো',
      'ফিল্ড স্ট্যাটাস রিপোর্ট প্রদান',
    ],
    recommendedFor: 'NOC / Field Ops',
  },
  {
    name: 'Sales Executive',
    summary: 'নতুন কানেকশন, বিক্রয় পাইপলাইন এবং রিমাইন্ডার পরিচালনার জন্য।',
    tasks: [
      'লিড/কানেকশন ফলোআপ',
      'বিক্রয় রিপোর্ট দেখা',
      'কালেকশন রিমাইন্ডার ট্র্যাকিং',
    ],
    recommendedFor: 'Sales / Collection',
  },
]

export default staffRoleInfo
